import styled, { css } from "styled-components";
import { motion } from "framer-motion";

export const SliderContainer = styled.div`
  display: ${({ show }) => (show ? "flex" : "none")};
  height: ${({ height }) => height}px;
  width: 100%;
  position: relative;
  align-items: center;
`;

export const SliderWrapper = styled(motion.div)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ $assetsGap }) => $assetsGap}px;

  height: 90%;
  width: 100%;

  ${({ $showButtons }) =>
    $showButtons
      ? css`
          margin: 0 1.5rem;
        `
      : ``};

  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  position: relative;

  &::-webkit-scrollbar {
    height: 6px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.adAssistant.previewBgColor};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.adAssistant.previewBorderColor};
  }

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.adAssistant.previewBorderColor} transparent;
`;

export const Arrow = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 0px;

  position: absolute;
  height: 90%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  border: transparent;
  border-radius: 2px;
  background: rgba(171, 180, 244, 0.4);
  cursor: pointer;

  // avoid overwriting the width of the parent
  width: auto !important;

  &:hover {
    background: ${({ theme }) => theme.colors.adAssistant.previewBorderColor};
  }

  &.left {
    left: 0;
  }

  &.right {
    right: 0;
  }
`;
